/*
 * quote-cart-foot.js
 * Sticky footer preview for the Quote Cart.
 * Now listens to the `quote:updated` event from quote-cart.js
 * instead of fetching Shopify's /cart.js (buy flow).
 *
 * 🚧 Opportunity for a diverged buy/checkout flow regarding current flow: QUOTE CART
 * Buy/checkout flow currently postponed — only quote flow is implemented.
 */

document.addEventListener('DOMContentLoaded', () => {
  const foot = document.querySelector('.quote-cart-foot');
  if (!foot) return;

  const list = foot.querySelector('.quote-cart-foot__list');
  const emptyMsg = foot.querySelector('.quote-cart-foot__empty');

  function refreshFooter() {
    // use window.quoteCart as the single source of truth for quote items
    const qc = window.quoteCart;
    if (!qc) {
      list.innerHTML = '';
      emptyMsg.style.display = 'block';
      return;
    }

    const items = qc.items || [];
    list.innerHTML = '';

    if (!items.length) {
      emptyMsg.style.display = 'block';
      return;
    }
    emptyMsg.style.display = 'none';

    items.forEach(item => {
      const li = document.createElement('li');
      li.className = 'quote-cart-foot__item';
      const img = (item.image && item.image !== 'undefined') ? item.image : '//placehold.co/40x40?text=No+Image';
      li.innerHTML = `
        <span class="thumb"><img class="quote-cart-foot__img" src="${img}" alt="${(item.title||'')}" loading="lazy"></span>
        <span class="info">${(item.title||'')} × ${item.qty}</span>
        <button class="remove" data-variant-id="${item.variantId}" aria-label="Remove">×</button>
      `;
      list.appendChild(li);
    });
  }

  // clicks inside footer -> remove
  foot.addEventListener('click', (e) => {
    const rem = e.target.closest('.remove');
    if (!rem) return;
    const variantId = rem.dataset.variantId;
    if (!variantId) return;
    // update quoteCart (single source)
    if (window.quoteCart) {
      window.quoteCart.removeItem(variantId);
      refreshFooter();
    }
  });

  // listen for updates from the main quote cart
  document.addEventListener('quote:updated', refreshFooter);

  // initial
  refreshFooter();
});
